import axios from 'axios';

class REST {
  constructor() {
    this.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }

  /**
   * Check if URL is SSL
   */
  _isSSL() {
    return /^https/i.test(this.baseURL);
  }

  /**
   * Get the Endpoint URL
   */
  _getURL(endpoint) {
    return `${this.baseURL}/${endpoint}`;
  }

  /**
   * Child class can override this method
   */
  requestDataFilter(data) {
    return data;
  }

  /**
   * Request the API
   *
   * @param  {String} method   HTTP method
   * @param  {String} endpoint API Endpoint
   * @param  {Object} params   API URL parameter for GET, UPDATE & DELETE method
   * @param  {Object} data     API parameter when using POST method
   * @return {Promise}
   */
  _request(method = 'get', endpoint, params = null, data = null) {
    const url = this._getURL(endpoint);

    // If user loggedin
    const token = localStorage.getItem('token');
    if (token) {
      this.headers.Authorization = `Bearer ${token}`;
    }

    const requestData = this.requestDataFilter({
      method,
      url,
      data,
      params,
      headers: this.headers,
    });

    return axios.request(requestData);
  }
}

export default REST;



// WEBPACK FOOTER //
// ./src/api/rest.js